var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaieuticaIconAzul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 83,
    viewBox: "0 0 124 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8218 13.6882L45.6814 19.6801H26.4077C25.842 19.6801 25.3116 19.9886 25.0287 20.481C24.7459 20.9763 24.7459 21.5903 25.0287 22.0857L40.186 48.5715L34.8733 76.4901C34.7731 77.0121 34.0925 77.1486 33.8008 76.7066L0.0975701 25.1766C-0.126371 24.8325 0.0533711 24.3727 0.451162 24.2748L46.1028 13C46.5183 12.8992 46.9013 13.264 46.8218 13.6882Z",
    fill: "#6B8EB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.227 17.7066L87.7855 76.1324C87.4054 76.7601 86.4536 76.5617 86.3534 75.8334L82.626 48.7062L97.7684 22.2954C98.0513 21.801 98.0513 21.1882 97.7655 20.6938C97.4826 20.2023 96.9552 19.8944 96.3865 19.8944H78.6658L76.0522 0.884968C75.9727 0.304706 76.5355 -0.151213 77.0835 0.0471412L122.826 16.5668C123.289 16.7356 123.483 17.2862 123.227 17.7066Z",
    fill: "#6B8EB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8354 21.7124L82.391 46.9542L61.9236 82.7189C61.8148 82.9083 61.6267 83 61.4386 83C61.2505 83 61.0594 82.9083 60.9536 82.7189L40.5685 47.0933L26.0418 21.7124C25.8272 21.3365 26.0976 20.866 26.5268 20.866H96.3475C96.7796 20.866 97.05 21.3365 96.8354 21.7124Z",
    fill: "#6B8EB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaieuticaIconAzul);
export default __webpack_public_path__ + "static/media/maieutica-icon-azul.5d876cece93fb8352e85fb148c136fab.svg";
export { ForwardRef as ReactComponent };